import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { DrawerContent } from "@/components/ui/drawer";
import { useFacilitiesContext } from "@/hooks/useFacilitiesContext";
import { useUnitItemContext } from "@/hooks/useUnitItemContext";
import { UnitPrice } from "@/components/units/unit/info/unitPrice";

export const JourneyFooter: React.FC = () => {
    const facilitiesContext = useFacilitiesContext();
    const unitContext = useUnitItemContext();
    const {unitGroup, selectedPromo} = unitContext;

    const {promo_rates} = unitGroup.rates;

    const selectedPromoObject = promo_rates?.find((element) => element.id === selectedPromo);

    const currentFacility = facilitiesContext.facilities.find((facility) => {return facility.id === unitGroup.representative_unit.facility_id})

    return (
        <DrawerContent>
            <div className="tw:p-4">
                <div className="tw:flex tw:items-center tw:justify-center tw:space-x-2">
                    <Card>
                        <CardHeader>
                            <CardTitle>Unit Information</CardTitle>
                        </CardHeader>
                        <CardContent>
                            <dl>
                                <dt>Unit Size:</dt>
                                <dd>{unitGroup.representative_unit.length}'x{unitGroup.representative_unit.width}'</dd>
                            </dl>
                            <dl>
                                <dt>Sq. Ft.:</dt>
                                <dd>{unitGroup.representative_unit.area}</dd>
                            </dl>
                            <dl>
                                <dt>Features:</dt>
                                <dd>{unitGroup.representative_unit.features.map(feature => feature.name).join(', ')}</dd>
                            </dl>
                            <UnitPrice rates={unitGroup.rates} />
                            {selectedPromoObject && (<dl>
                                <dt>Special:</dt>
                                <dd>{selectedPromoObject.name}</dd>
                            </dl>)}
                        </CardContent>
                    </Card>
                    <Card>
                        <CardHeader>
                            <CardTitle>{currentFacility?.name ?? ""}</CardTitle>
                            <CardContent>
                                <address>
                                    {currentFacility?.address_1}<br />{currentFacility?.city}, {currentFacility?.state} {currentFacility?.zipcode} <br/>
                                    <span className="facility-phone">Phone: <strong>{currentFacility?.phone}</strong></span>
                                </address>
                            </CardContent>
                        </CardHeader>
                    </Card>
                </div>
            </div>
        </DrawerContent>
    );
};
